var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowSquareDownRight = function SvgIconArrowSquareDownRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.625 10.125a1 1 0 1 1 2 0v4.503a.997.997 0 0 1-.997.997h-4.503a1 1 0 1 1 0-2h2.086l-3.543-3.543a1 1 0 0 1 1.414-1.414l3.543 3.543z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.5 2.75c.966 0 1.75.784 1.75 1.75v15a1.75 1.75 0 0 1-1.75 1.75h-15a1.75 1.75 0 0 1-1.75-1.75v-15c0-.966.784-1.75 1.75-1.75zm-.25 2H4.75v14.5h14.5z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconArrowSquareDownRight;